import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { initSentry } from './lib/sentry';
import App from './App';
import './index.css';

// Initialize Sentry before app renders (no-op if VITE_SENTRY_DSN not set)
initSentry();

// Initialize i18n before app renders
import i18n from './i18n';

const updateSW = registerSW({
  onNeedRefresh() {
    // Prevent duplicate banners
    if (document.getElementById('sw-update-banner')) return;

    const banner = document.createElement('div');
    banner.id = 'sw-update-banner';
    banner.style.cssText =
      'position:fixed;top:0;left:0;right:0;z-index:9999;padding:12px 16px;background:#2D6A4F;color:white;display:flex;align-items:center;justify-content:space-between;font-size:14px;font-family:DM Sans,sans-serif;box-shadow:0 2px 8px rgba(0,0,0,0.15)';

    const text = document.createElement('span');
    text.textContent = i18n.t('pwa.updateAvailable', { ns: 'common', defaultValue: 'A new version is available' });

    const btn = document.createElement('button');
    btn.textContent = i18n.t('pwa.update', { ns: 'common', defaultValue: 'Update' });
    btn.style.cssText =
      'background:white;color:#2D6A4F;border:none;padding:6px 16px;border-radius:8px;font-weight:600;font-size:13px;cursor:pointer;font-family:inherit';
    btn.onclick = () => {
      banner.remove();
      updateSW(true);
    };

    banner.appendChild(text);
    banner.appendChild(btn);
    document.body.appendChild(banner);
  },
});

function LoadingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <App />
    </Suspense>
  </React.StrictMode>,
);
